import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalStorageUtils } from "../utils/index.js";
import { UserContextActionCreators } from "../redux/action-creators/index.js";
import { UserContextSelectors } from "../redux/selectors/index.js";

export const useMiniCashierInit = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const miniCashierEnabled = useSelector(
    UserContextSelectors.miniCashierEnabled
  );
  const updateMiniCashierDetails = useCallback(
    details =>
      dispatch(UserContextActionCreators.updateMiniCashierDetails(details)),
    [dispatch]
  );

  useEffect(() => {
    if (isAuthenticated && miniCashierEnabled) {
      const details = LocalStorageUtils.get("MiniCashierDetails") || {
        IsEligible: false
      };
      updateMiniCashierDetails(details);
    }
  }, [isAuthenticated, miniCashierEnabled, updateMiniCashierDetails]);
};
